import React, { useState, useEffect } from 'react'
import SecondaryButton from '../../components/atoms/SecondaryButton/index'
import PrimaryButton from '../../components/atoms/PrimaryButton/index'
import { isEmpty, findIndex } from 'lodash'
import Pagination from '@material-ui/lab/Pagination'
import { getPaginationCount } from '../../Utils/Utility'
import { useHistory } from 'react-router-dom'
import './wonAuction.css'
import { handleRedirectInternal } from '../../common/components'
import Switch from '@material-ui/core/Switch'
import { currencyFormat } from '../../common/components'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormGroup from '@material-ui/core/FormGroup'
import Tooltip from '@material-ui/core/Tooltip'
import Swal from 'sweetalert2'
import { connect, useDispatch, useSelector } from 'react-redux'
import Popup from '../../components/organisms/Popup'
import moment from 'moment'
const WonAuction = (props) => {
    const data = ['Paid', 'Unpaid', 'Unpaid', 'Unpaid', 'Paid', 'Paid']
    const history = useHistory()
    const [invoice_id, setInvoice] = useState([])
    const [unpaid_count, setInvoicecount] = useState(0)
    const [total_amount, setTotalamount] = useState(0)
    const [include_trasactionfee, setTrasactionfee] = useState(true)
    const [transaction_fee_enable, setTransactionEnable] = useState(0)
    const [sales_tax, setSalesTax] = useState(0)
    const [modalOpen, setmodalOpen] = useState(false)
    const state_header = useSelector((state) => state.storeDetails)
    const [transaction_fee_percent, setTransactionFeePercent] = useState(3.1)
    useEffect(() => {
        if (state_header?.storeDetails?.store_configuration?.length > 0) {
            state_header.storeDetails.store_configuration.map((data) => {
                if (data.variable == 'transaction_fee_changes' && data.value == '1') {
                    setTransactionEnable(1)
                }
                if (data.variable == 'sales_tax') {
                    setSalesTax(parseFloat(data.value))
                }
                if (data.variable == 'transaction_fee_percent') {
                    setTransactionFeePercent(parseFloat(data.value))
                }
            })
        }
    }, [state_header])
    const add_to_card = (data) => {
        var arr = invoice_id
        var temp = []
        if (arr.includes(data.common_invoice)) {
            temp = arr.filter((val) => val != data.common_invoice)
        } else {
            temp = [...arr, data.common_invoice]
        }
        setInvoice(temp)
    }

    useEffect(() => {
        if (!isEmpty(props.data.results)) {
            var temp = [],
                arr = [],
                unpaid_count_local = 0,
                total_amount = 0
            props.data.results.map((data) => {
                arr = temp
                if (new Date(data.buynowdate_added) > new Date('12/16/2023 00:00:00')) {
                    if (data.paid == 0) {
                        unpaid_count_local = unpaid_count_local + 1
                        if (arr.includes(data.common_invoice)) {
                            // temp = arr.filter((val) => val != data.common_invoice)
                        } else {
                            temp = [...arr, data.common_invoice]
                        }
                    }
                    if (transaction_fee_enable) {
                        var total_amount_pre =
                            parseFloat(data.buynowamount) +
                            parseFloat(data.shippingcost) +
                            parseFloat(
                                (parseFloat(data.buynowamount) *
                                    parseFloat(data.buyerpremium_percentage)) /
                                    100,
                            ) +
                            parseFloat(
                                (parseFloat(data.buynowamount) * parseFloat(sales_tax)) / 100,
                            )
                        data.transaction_fee = parseFloat(
                            parseFloat(
                                parseFloat(
                                    (parseFloat(total_amount_pre) * transaction_fee_percent) / 100,
                                ) + 0.3,
                            ).toFixed(2),
                        )
                        data.total_amount =
                            parseFloat(total_amount_pre) + parseFloat(data.transaction_fee)
                    } else {
                        data.transaction_fee = parseFloat(
                            parseFloat(
                                parseFloat(
                                    (parseFloat(data.buynowamount) * transaction_fee_percent) / 100,
                                ) + 0.3,
                            ).toFixed(2),
                        )
                        data.total_amount =
                            parseFloat(data.buynowamount) + parseFloat(data.transaction_fee)
                    }

                    if (data.paid == 0) {
                        total_amount = parseFloat(total_amount) + parseFloat(data.total_amount)
                    }
                }
            })
            setInvoice(temp)
            setInvoicecount(unpaid_count_local)
            setTotalamount(total_amount)
        }
    }, [props.data, transaction_fee_enable])

    const MovetoCheckout = () => {
        if (parseFloat(total_amount) > 1000) {
            Swal.fire({
                title: 'An Invoice Will Be Emailed To You Shortly',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                position: 'center',
            })
        } else {
            window.location.href = `Checkout?id=${invoice_id.join('&id=')}`
        }
    }

    const modalClose = () => {
        setmodalOpen(!modalOpen)
    }

    return (
        <div>
            <div className="wonAuction-Table table-responsive">
                <table className="table">
                    <thead className="thead-light">
                        {/* <tr>
                            <td colSpan="10"></td>
                            <td colSpan="2">
                                <SecondaryButton
                                    label={`Checkout (${unpaid_count})`}
                                    onClick={() => {
                                        // history.push({
                                        //     pathname: `/Checkout?id=${invoice_id.join('&id=')}`,
                                        //     state: {},
                                        // })
                                        if (parseInt(unpaid_count) > 0) {
                                            MovetoCheckout()
                                        }

                                        // handleRedirectInternal(
                                        //     history,
                                        //     `Checkout?id=${invoice_id.join('&id=')}`,
                                        // )
                                    }}
                                    disabled={parseInt(unpaid_count) > 0 ? true : false}
                                />
                            </td>
                        </tr> */}
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Auction Name</th>
                            <th scope="col">Title</th>
                            <th scope="col">Quantity</th>
                            <th scope="col"> Date Ended</th>
                            <th scope="col">Won Amount</th>
                            {/* <th scope="col">
                                {' '}
                                <div className="row">
                                    <p>Transaction Fee</p>
                                    <Tooltip
                                        placement="top"
                                        title={
                                            <div
                                                style={{
                                                    width: '300px',
                                                    padding: '5px',
                                                    fontSize: '18px',
                                                    color: 'white',
                                                }}
                                            >
                                                (3.1% + 30 cents) of won amount.
                                            </div>
                                        }
                                        arrow
                                    >
                                        <span className="material-icons">info</span>
                                    </Tooltip>
                                </div>{' '}
                            </th> */}
                            {/* <th colSpan="5">
                                {include_trasactionfee ? 'Card Fee' : 'Check/ACH Payment'}
                                <div className="tableSwitch">
                                    <div className="das-togle-switch">
                                        <Switch
                                            checked={include_trasactionfee}
                                            onChange={(event) =>
                                                setTrasactionfee(event.target.checked)
                                            }
                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                        />
                                    </div>
                                    <Tooltip
                                        placement="top"
                                        title={
                                            <div
                                                style={{
                                                    // width: '300px',
                                                    // padding: '5px',
                                                    fontSize: '16px',
                                                    lineHeight: '24px',
                                                }}
                                            >
                                                Switch off to view total amount without transaction
                                                fee.
                                            </div>
                                        }
                                        arrow
                                    >
                                        <span className="material-icons">info</span>
                                    </Tooltip>
                                </div>
                            </th> */}
                            {/* <th scope="col">Action</th> */}
                            {/* <th scope="col">Invoice</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {!isEmpty(props.data.results) ? (
                            <>
                                {props.data.results.map((data, index) => (
                                    <tr>
                                        <th scope="row" className="frstHdrRow">
                                            {data.sku}
                                        </th>
                                        <td>{data.auctionlot_title}</td>
                                        <td>
                                            {' '}
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: data.title,
                                                }}
                                            ></p>
                                        </td>
                                        <td>{data.qty}</td>
                                        <td>{moment(data.date_closed).format('MM/DD/YYYY')}</td>
                                        <td>{currencyFormat(parseFloat(data.buynowamount))}</td>
                                        {/* <td>{currencyFormat(parseFloat(data.transaction_fee))}</td> */}
                                        {/* <td colSpan="5">
                                            {data.paid === 0 &&
                                            new Date(data.buynowdate_added) >
                                                new Date('12/16/2023 00:00:00') ? (
                                                <>
                                                    {currencyFormat(
                                                        parseFloat(
                                                            include_trasactionfee
                                                                ? data.total_amount
                                                                : data.buynowamount,
                                                        ),
                                                    )}
                                                </>
                                            ) : (
                                                '-'
                                            )}
                                        </td> */}
                                        {/* <td className={data}>{data.dateclosing}</td> */}
                                        {/* <td>
                                            <SecondaryButton
                                                label="Invoice"
                                                onClick={() => {
                                                    if (
                                                        new Date(data.buynowdate_added) >
                                                        new Date('12/16/2023 00:00:00')
                                                    ) {
                                                        history.push(
                                                            `/New_Invoice/${data.common_invoice}`,
                                                        )
                                                    } else {
                                                        history.push(
                                                            `/Invoice/${data.common_invoice}`,
                                                        )
                                                    }
                                                }}
                                            />
                                        </td> */}
                                    </tr>
                                ))}
                            </>
                        ) : (
                            <tr>
                                <td colspan="12" className="border-none">
                                    <div className="card card-body text-center mt-2">
                                        <b>No Auction Found</b>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {props.data.total_pagecnt ? (
                <div className="won-pgn">
                    <Pagination
                        onChange={(e, value) => {
                            props.paramsupd(value)
                        }}
                        count={
                            props.data.total_pagecnt
                                ? getPaginationCount(props.data.total_pagecnt, 10)
                                : '1'
                        }
                    />
                </div>
            ) : (
                ''
            )}
            <Popup
                modaltitle="Payment Information"
                open={modalOpen}
                handleClose={() => modalClose()}
            >
                {' '}
                <div className="p-4 descFldDynTxt">
                    <div className="container">Transaction fee is only for a credit card.</div>
                </div>
            </Popup>
        </div>
    )
}

export default WonAuction
